module.exports = __webpack_public_path__ + "static/button-limitprimaryactions-do-1f599ac56f848e586055db7e8c908f6a.png";